// extracted by mini-css-extract-plugin
export default {"input":"P8diUXaE"};